import { createElement, Component } from 'react';
import { node, bool, func } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import { b as iconPropTypes } from '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import 'reakit/Navigation';
import '../Navigation/styled.js';
import '../chunk-18be6601.js';
import '../Navigation/index.js';
import '../chunk-5c9bbccf.js';
import 'reakit/Popover';
import '../Popover/PopoverContainer.js';
import '../Popover/styled.js';
import '../Popover/PopoverHide.js';
import '../Popover/PopoverClose.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Popover/PopoverPopover.js';
import '../Popover/PopoverShow.js';
import '../Popover/PopoverToggle.js';
import '../chunk-8dd1e1d3.js';
import 'reakit/Divider';
import '../Divider/styled.js';
import '../Divider/index.js';
import '../Popover/index.js';
import { MenuItem as MenuItem$1, MenuIcon } from './styled.js';
import { withMenuContext } from './MenuContext.js';

var menuItemPropTypes = {
  children: node.isRequired,
  hideOnClick: bool,
  icon: iconPropTypes['icon'],
  isActive: bool,
  isDisabled: bool,
  onClick: func
};
var menuItemDefaultProps = {
  hideOnClick: true,
  icon: undefined,
  isActive: false,
  isDisabled: false,
  onClick: undefined
};
var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var _this$props = _this.props,
          context = _this$props.context,
          hideOnClick = _this$props.hideOnClick,
          onClick = _this$props.onClick;
      onClick && onClick(e);
      hideOnClick && context && context.hide();
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          icon = _this$props2.icon,
          isDisabled = _this$props2.isDisabled,
          props = _objectWithoutPropertiesLoose(_this$props2, ["children", "icon", "isDisabled"]);

      return createElement(MenuItem$1, _extends({
        role: "menuitem",
        disabled: isDisabled
      }, props, {
        onClick: _this.handleClick,
        type: "button"
      }), icon && // @ts-ignore
      createElement(MenuIcon, {
        a11yHidden: true,
        icon: icon
      }), children);
    });

    return _this;
  }

  return MenuItem;
}(Component); // @ts-ignore

_defineProperty(MenuItem, "propTypes", menuItemPropTypes);

_defineProperty(MenuItem, "defaultProps", menuItemDefaultProps);

var C = withMenuContext(MenuItem);

export default C;
export { MenuItem, menuItemDefaultProps, menuItemPropTypes };
